var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDestPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Pin-2",
    "data-name": "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0464,8.4834a10,10,0,0,0-7.9116-5.4258,11.3644,11.3644,0,0,0-2.2691,0A10.0027,10.0027,0,0,0,6.9536,8.4829a10.8062,10.8062,0,0,0,1.481,11.8936l6.7929,8.2588a1,1,0,0,0,1.545,0l6.7929-8.2588A10.8055,10.8055,0,0,0,25.0464,8.4834ZM16,17a4,4,0,1,1,4-4A4.0047,4.0047,0,0,1,16,17Z",
    style: {
      fill: "#262628"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestPin);
export default __webpack_public_path__ + "static/media/dest-pin.61d38d73ed5ff99fcf4c4590357aef83.svg";
export { ForwardRef as ReactComponent };